import styled from 'styled-components';

export default styled.canvas`
  transform: scale(${props => 1 / props.dpr});
  transform-origin: 0 0;
`;
